module.exports = __webpack_public_path__ + "static/media/icono_like_lleno.53440fe1.svg";